$(document).ready(function () {
  $('.attorney-carousel').slick({
    slide: '.attorney-carousel__slide',
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    adaptiveHeight: true,
    arrows: false,
    dots: true,
    rows: 0
  });

  $('.attorney-carousel__arrow-prev').on('click', function() {
    console.log('previous arrow')
    $('.attorney-carousel').slick('slickPrev')
  })

  $('.attorney-carousel__arrow-next').on('click', function() {
    $('.attorney-carousel').slick('slickNext')
  })
})